import { useState, useEffect, useContext, useMemo } from 'react'
import { useLocation, useParams, useNavigate } from 'react-router-dom'

import GiftcardEditor from './pass-editor-gift'
import EventTicketEditor from './pass-editor-event'
import StampcardEditor from './pass-editor-stamp'
import LoyaltyEditor from './pass-editor-loyalty'
import MembershipEditor from './pass-editor-membership'

import { AppContext } from '/providers/app-context'
import { getPass } from '/providers/passes-api'

import PageWrapper from '/components/page-wrapper'
import StyledPaper from '/components/paper'
import HelpText from '/help/pass-scan-actions'
import Menu from '/components/passes/pass-nav-menu'

const PassScanActions = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const { templateId, passId } = useParams()

  const { apiSource, apiKey, templates, setPasses } = useContext(AppContext)

  const [pass, setPass] = useState(location.state?.pass)
  const template = useMemo(() => { return templates.filter(t => t.template_id === templateId)[0] }, [templates, templateId])

  useEffect(() => {
    getPassData()
  }, [])

  const getPassData = async () => {
    const p = await getPass({ apiSource, apiKey, passId })
    if (p.ok === false || !p.pass) return navigate("/templates")
    setPasses(current => {
      const idx = current.findIndex(item => item.template_id === templateId && item.pass_id === passId)
      if (idx < 0) return [...current, p.pass]
      const next = [...current]
      next[idx] = p.pass
      return next
    })
    setPass(p.pass)
  }

  const setLocationStatePass = pass => {
    setPass(pass)
    setPasses(current => {
      const idx = current.findIndex(item => item.template_id === templateId && item.pass_id === passId)
      if (idx < 0) return [...current, pass]
      const next = [...current]
      next[idx] = pass
      return next
    })
    navigate(location.pathname, { replace: true, state: { ...location.state, pass } })
  }

  if (template?.managed_pass_template === 1) return (
    <PageWrapper title="Pass Editor" HelpText={HelpText} heading={`${pass?.pass_id} ${pass?.mode === "test" ? " [test]" : ""}`} menu={<Menu pass={pass} template={template} />}>
      <StyledPaper sx={{ flex: 1, minWidth: 0, height: '100%' }}>
        <SmartixScannerEditForm pass={pass} template={template} setPass={setLocationStatePass} />
      </StyledPaper>
    </PageWrapper>
  )
}

export default PassScanActions


const SmartixScannerEditForm = ({ pass, template, setPass }) => {

  if (pass && template)
    switch (template?.pass_type_id) {
      case "managed_gift": return <GiftcardEditor pass={pass} template={template} setPass={setPass} />
      case "managed_stamp": return <StampcardEditor pass={pass} template={template} setPass={setPass} />
      case "managed_event": return <EventTicketEditor pass={pass} template={template} setPass={setPass} />
      case "managed_event_bg": return <EventTicketEditor pass={pass} template={template} setPass={setPass} />
      case "managed_loyalty": return <LoyaltyEditor pass={pass} template={template} setPass={setPass} />
      case "managed_membership": return <MembershipEditor pass={pass} template={template} setPass={setPass} />
      case "managed_membership_sc": return <MembershipEditor pass={pass} template={template} setPass={setPass} />
    }
}
